import { LitElement, css, html } from 'lit';
import { customElement } from 'lit/decorators.js';
import { classMap } from 'lit/directives/class-map.js';
import { getGlobalStyleSheets } from '../../global-styles';
import { IClassMap } from '../helpers';
import * as TagNames from './panels.tagnames';

@customElement(TagNames.MultiTab)
export class AtlMultiTabPanel extends LitElement {
   declare className: string;
   declare panelBorder: boolean;

   static properties = {
      className: { type: String },
      panelBorder: { type: Boolean },
   };

   static styles = [
      ...getGlobalStyleSheets(),
      css`
         :host {
            display: block;
         }
      `,
   ];

   render() {
      const classNames: IClassMap = { card: true, 'multitab-panel': true };
      if (this.className) {
         classNames[this.className] = true;
      }
      return html`
         <div part="panel" class=${classMap(classNames)}>
            <slot></slot>
         </div>
      `;
   }
}
